const initials = "userBalance/";
export const UPDATE_USER_BALANCE = `${initials}UPDATE_USER_BALANCE`;

